module.exports = __webpack_public_path__ + "img/home_atrategy__img3——vi.020ee138.png";